import './style.scss'
import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useErrorBoundary } from "react-error-boundary";
import useEnvInitData from '@/hooks/useEnvInitData'
import { BackButton, MainButton, useWebApp } from "@vkruglikov/react-telegram-web-app";
import { Trans, useTranslation } from "react-i18next";
import Select from 'react-select'
import makeAnimated from 'react-select/animated';
import BottomSheet from 'react-draggable-bottom-sheet';
import IconClose from "@/icons/close.svg";
import { HandySvg } from 'handy-svg';
import SettingsApi from '@/features/Settings/api'

const animatedComponents = makeAnimated();

export default function Countries({ data, setData, back }) {
	const { raffle_id } = useParams();
	const { showBoundary } = useErrorBoundary()
	const [InitDataUnsafe, InitData] = useEnvInitData();
	const { t } = useTranslation()
	const [countries, setCountries] = useState([]);
	const allowKey = useRef(data.countries.values.allow ?? 'allow')
	const disallowKey = useRef(data.countries.values.disallow ?? 'disallow')
	const [value, setValue] = useState(allowKey.current)
	const [valueCountries, setValueCountries] = useState([])
	const [confirm, setConfirm] = useState(false)

	useEffect(() => {
		if (data.countries.codes) {
			const countryArray = data.countries.codes.map(code => ({
				value: code,
				label: t('countries.' + code),
			}));
			setCountries(countryArray);
		}

		if (data.countries.raffle) {
			if (data.countries.raffle[allowKey.current]) {
				setValue(allowKey.current)
				setValueCountries(data.countries.raffle[allowKey.current])
			}
			if (data.countries.raffle[disallowKey.current]) {
				setValue(disallowKey.current)
				setValueCountries(data.countries.raffle[disallowKey.current])
			}
		}
	}, [data.countries])

	const [saving, setSaving] = useState(false)
	const handleSave = () => {
		if (saving) return;
		setSaving(true);

		SettingsApi.countriesSave({
			initData: InitData,
			raffle: raffle_id,
			value: value,
			countries: valueCountries
		}).then(function(result) {
			if (result.result) {
				setConfirm(false)
				WebApp.close()
			}
		}).catch((e) => {
			showBoundary(e)
		}).finally(() => {
			setSaving(false)
			setData(prev => ({
				...prev,
				countries: {
					...prev.countries,
					raffle: {
						[value]: valueCountries
					}
				}
			}));
		})
	}

	const WebApp = useWebApp();

	return (
		<div className='Countries'>
			<BackButton onClick={back} />
			<div className='boxTitle'>{t('features.settings.countries.title')}</div>
			<div className='boxText'>
				<div className='boxText_body'>
					<div className='switcher'>
						<button
							onClick={() => setValue(allowKey.current)}
							className={'switcher__btn' + (value === allowKey.current ? ' switcher__btn--active' : '')}
						>
							{t('features.settings.countries.allow.btn')}
						</button>
						<button
							onClick={() => setValue(disallowKey.current)}
							className={'switcher__btn' + (value === disallowKey.current ? ' switcher__btn--active' : '')}
						>
							{t('features.settings.countries.disallow.btn')}
						</button>
					</div>
				</div>
				<div className='boxText_footer'>
					<Trans i18nKey="features.settings.countries.text" components={{ b: <b />, br: <br /> }} />
				</div>
			</div>
			<div className='boxText'>
				<div className='boxText_body'>
					<Select
						isMulti
						options={countries}
						value={countries.filter((item) => valueCountries.includes(item.value))}
						className='Countries__select'
						placeholder={t('features.settings.countries.select.placeholder')}
						classNames={{
							control: (state) => 'Countries__select-control ' + (state.isFocused ? ' Countries__select-control--focus' : ''),
							valueContainer: (state) => 'Countries__select-control__value-wrap',
							singleValue: (state) => 'Countries__select-control__value',
							multiValue: (state) => 'Countries__select-control__value-multi',
							multiValueLabel: (state) => 'Countries__select-control__value-multi__label',
							placeholder: (state) => 'Countries__select-control__placeholder',
							indicatorsContainer: (state) => 'Countries__select-control__indicatorsContainer',
							menu: (state) => 'Countries__select-menu',
							menuList: (state) => 'Countries__select-menu__list',
							option: (state) => `Countries__select-item ${state.isSelected ? 'Countries__select-item--selected' : ''} ${state.isFocused ? 'Countries__select-item--hovered' : ''}`,
						}}
						components={{
							...animatedComponents,
							IndicatorSeparator: () => null,
						}}
						onChange={(selectedOptions) => {
							setValueCountries(selectedOptions.map(option => option.value));
						}}
						noOptionsMessage={({inputValue}) => !inputValue ? inputValue : t('features.settings.countries.select.notFound')}
					/>
				</div>
			</div>
			{!data.is_vip ?
				<div className='boxText'>
					<div className='boxText_body'>
						<p>{ t('features.settings.vip_text') }</p>
						<button
							className='btn btn--block btn--light btn--tt-none'
							onClick={() => {
								WebApp.openTelegramLink(process.env.REACT_APP_LINK_TO_BOT + '?start=vip-clear')
								WebApp.close()
							}}
						>
							{ t('features.settings.vip_btn') }
						</button>
					</div>
				</div>
			:
				<MainButton
					className='btn btn--block'
					onClick={() => confirm ? handleSave() : setConfirm(true)}
					disabled={saving}
					progress={saving}
					text={confirm ? t('features.settings.countries.save') : t('features.settings.countries.confirm_btn')}
				/>
			}
			{confirm ?
				<BottomSheet isOpen={confirm} close={() => setConfirm(false)} disabled>
					<button className='BottomSheetClose' onClick={() => setConfirm(false)}><HandySvg src={IconClose}/></button>
					<div className='boxText'>
						<div className='boxText_body'>
							{valueCountries.length === 0 ?
								<b>{ t('features.settings.countries.confirm_text_empty') }</b>
							:
								<>
									<b>{ value === allowKey.current ? t('features.settings.countries.confirm_text_allow') : t('features.settings.countries.confirm_text_disallow') }</b>
									<p>{countries.filter((item) => valueCountries.includes(item.value)).map(item => item.label).join(', ')}</p>
									<p>{t('features.settings.countries.confirm_text_warning')}</p>
								</>
							}

						</div>
					</div>
				</BottomSheet>
			: null}
		</div>
	)
}
